import { render, staticRenderFns } from "./addMayoristaForm.vue?vue&type=template&id=4c9bd5de&scoped=true"
import script from "./addMayoristaForm.vue?vue&type=script&lang=js"
export * from "./addMayoristaForm.vue?vue&type=script&lang=js"
import style0 from "./addMayoristaForm.vue?vue&type=style&index=0&id=4c9bd5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9bd5de",
  null
  
)

export default component.exports